module.exports = __webpack_public_path__ + "img/slide1.70e7245c.png";